export type LeaveTypeReason =
  | 'sick'
  | 'compassionate'
  | 'holiday'
  | 'other'
  | 'unknown';

export type LeaveType = `op:leave:${LeaveTypeReason}` | string;

export type TimeOffScope = 'employee' | 'company';

export enum TimeOffStatus {
  taken = 'taken',
  scheduled = 'scheduled',
  deleted = 'deleted',
}

export type BaseTimeOff = {
  id: string;
  leaveType: LeaveType;
  employeeId: string;
  companyId: string;
  employeeNote: string;
  startDate: string;
  endDate: string;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
  deletedBy?: string;
  deletedAt?: string;
  isTaken: boolean;
  firstDayAfternoonOnly?: boolean;
  lastDayMorningOnly?: boolean;
};

export type TimeOffWithScope<T extends TimeOffScope> = T extends 'company'
  ? BaseTimeOff & { employeeName: string }
  : BaseTimeOff;

export type TimeOff<T extends TimeOffScope = 'employee'> =
  TimeOffWithScope<T> & {
    status: TimeOffStatus;
  };

export type TimeOffCompany = TimeOff<'company'>;

export type TimeOffEmployee = TimeOff<'employee'>;

export type TimeOffType = {
  id: string;
  name: string;
  countryCode: string;
};

/**
 * Domain
 */

export type CreateTimeOffRequest = BaseTimeOff & {
  hasConfirmedWithManager: boolean;
};

export type GetTimeOffTypesResponse = TimeOffType[];
